<template>
  <div class="header" :class="{headerHome: showHome, headerNew: opacity}">
    <div class="logo" @click="toHome()">
      <img :src="showHome ? logoWhite : logoBlack" alt="兮易强企"/>
    </div>
    <el-menu :default-active="activeIndex" mode="horizontal" text-color="#3c3c3c" active-text-color="#0e7ae3"
      @select="handleSelect">
      <el-menu-item index="/home">首页</el-menu-item>
      <el-submenu index="2">
        <template slot="title">产品</template>
        <el-menu-item index="/product/consultation">企业核心能力评估诊断</el-menu-item>
        <el-menu-item index="/product/talents">组织与人才发展</el-menu-item>
        <el-menu-item index="/product/cloud">产业云图</el-menu-item>
        <el-menu-item index="/product/digitalHuman">岗位数字人</el-menu-item>
      </el-submenu>
      <el-submenu index="3">
        <template slot="title">解决方案</template>
        <el-menu-item index="/solution/planning">企业核心能力咨询规划</el-menu-item>
        <el-menu-item index="/solution/talentDevelopment">组织与人才发展</el-menu-item>
      </el-submenu>
      <el-submenu index="4">
        <template slot="title">智能制造</template>
        <el-menu-item index="/intelligent/index">智能产品</el-menu-item>
        <el-menu-item index="/intelligent/solution">解决方案</el-menu-item>
      </el-submenu>
      <!-- <el-menu-item index="/platform/index">平台服务</el-menu-item> -->
      <el-menu-item index="/case/list">客户案例</el-menu-item>
      <el-menu-item index="/news/list">新闻动态</el-menu-item>
      <el-menu-item index="/about/index">关于我们</el-menu-item>
      <div class="menu-button">
        <a href="https://www.xiyiqq.com/cciai/member/signIn" target="_blank" class="service-btn">服务入口</a>
      </div>

    </el-menu>
    <!-- <el-input v-model="input" placeholder="输入关键字搜索..." class="header-input">
      <i slot="prefix" class="el-input__icon el-icon-search"></i>
    </el-input> -->
  </div>
</template>

<script>
import logoBlack from '@/assets/images/footer-logo.png'
import logoWhite from '@/assets/images/white-logo.png'
export default {
  data() {
    return {
      activeIndex: "/",
      scrollTop: 0,
      logoBlack,
      logoWhite,
      input: '',
      whiteHeaderPath: ['/case/details', '/news/details'],
      serverUrl: serverUrl
    };
  },
  watch: {
    $route(to, from) {
      this.activeIndex = to.path
    }
  },
  created() {
    this.activeIndex = this.$route.path
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  // beforeDestroy() {
  //   window.removeEventListener('scroll', this.handleScroll);
  // },
  methods: {
    handleSelect(path) {
      this.$router.push({ path })
    },
    handleScroll() {
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;

    },
    toHome() {
      this.$router.push({ path: '/' })
    }
  },
  computed: {
    bgOpacity () {
      return {
        // background: "rgba(0,0,0," + this.scrollTop / 120 + ")"
        background: '#fff'
      };
    },
    opacity () {
      return this.scrollTop == 0 && !this.whiteHeaderPath.includes(this.activeIndex)
    },
    showHome () {
      return this.scrollTop == 0 && this.activeIndex == '/home'
    },
  }
};
</script>

<style scoped lang="scss">
.header {
  z-index: 99;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  min-width: 1400px;
  height: 60px;
  display: flex;
  align-items: center;
  padding: 0 51px;
  background-color: #fff;
  box-shadow: 0px 4px 5px 0px rgba(189, 189, 189, 0.25);

  .logo {
    height: 25px;
    width: auto;
    margin-right: 40px;

    img {
      width: 135px;
      height: 100%;
    }
  }

  /deep/ .el-menu {
    background: rgba(0, 0, 0, 0);
    border-bottom: none;
    display: flex;

    .el-menu-item,
    .el-submenu__title {
      font-size: 16px;
    }

    .el-submenu__icon-arrow {
      display: none !important;
    }
    .el-menu-item {
      color: #3C3C3C!important;
      &:hover {
        background-color: transparent !important;
        color: #1C8EFF !important;
      }
    }
    .el-menu-item.is-active {
      color: #1C8EFF!important;
      border-bottom-color: #1C8EFF!important;
      background-color: transparent !important;
    }
    .el-submenu.is-active {
      .el-submenu__title {
        color: #1C8EFF!important;
        border-bottom-color: #1C8EFF!important;
        background-color: transparent !important;
      }
    }
    .el-submenu__title {
      color: #3C3C3C!important;
      &:hover {
        background-color: transparent !important;
        color: #1C8EFF !important;
      }
    }

    li {
      margin-right: 40px;
    }
  }
  .header-input {
    width: 174px;
    height: 30px;
    margin-left: 251px;
    /deep/ .el-input__inner {
      height: 30px;
      line-height: 30px;
      background-color: transparent;
      border: 1px solid #3C3C3C;
      border-radius: 15px;
      color: #3c3c3c;
      &::placeholder {
        color: #3C3C3C;
        font-size: 12px;
      }
    }
    /deep/ .el-input__icon {
      line-height: 30px;
      color: #3c3c3c;
    }
  }
  .menu-button {
    height: 60px;
    display: flex;
    align-items: center;
  }
  .service-btn {
    font-size: 12px;
    color: #fff;
    width: 98px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    background: #1480e4;
    display: inline-block;
    &:hover {
      color: #fff;
    }
  }
}
.headerNew {
  background-color: transparent;
  box-shadow: none;
}
.headerHome {
  background-color: transparent;
  box-shadow: none;
  /deep/ .el-menu {
    .el-menu-item {
      color: #B2BAC2!important;
      &:hover {
        color: #fff !important;
      }
    }
    .el-menu-item.is-active {
      color: #fff!important;
      border-bottom-color: #fff!important;
    }
    .el-submenu.is-active {
      .el-submenu__title {
        color: #fff!important;
        border-bottom-color: #fff!important;
      }
    }
    .el-submenu__title {
      color: #B2BAC2!important;
      &:hover {
        color: #fff !important;
      }
    }
  }
  .header-input {
    /deep/ .el-input__inner {
      border-color:#fff;
      color: #fff;
      &::placeholder {
        color: #B2BAC2;
      }
    }
    /deep/ .el-input__icon {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue